import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CoreSidebarService} from '../../../../@core/components/core-sidebar/core-sidebar.service';
import {AlertService} from '../../../shared/services/alert.service';
import {HttpClient} from '@angular/common/http';
import {GlobalService} from '../../../shared/services/global.service';
import {CategoryService} from '../../../shared/services/category.service';
import {CourseService} from '../../../shared/services/course.service';
import {UniversityService} from '../../../shared/services/university.service';
import {EbookService} from '../../../shared/services/ebook.service';

@Component({
  selector: 'app-add-ebook',
  templateUrl: './add-ebook.component.html',
  styleUrls: ['./add-ebook.component.scss']
})
export class AddEbookComponent implements OnInit {
  addBookForm: FormGroup;
  id: any;
  category: any;
  universities: any = [];
  courses: any = [];
  semesters: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  bookFileId: any;
  inputTypePassword: any = 'password';
  submitted: any = false;
  submitting: any = false;
  @Output() valueSubmitted = new EventEmitter<any>();
  @Input() data: any;
  onFileChanged: any;
  uploadedBookUrl: string | null = null;
  constructor(private _coreSidebarService: CoreSidebarService,
              private fb: FormBuilder,
              private alertService: AlertService,
              public http: HttpClient,
              public globalService: GlobalService,
              public categoryService: CategoryService,
              private ebookService: EbookService,
              private universityService: UniversityService,
              private courseService: CourseService) {
  }

  ngOnInit(): void {
    }

  ngOnChanges(): void {
    this.refresh();
    this.getCategory();
    this.getUniversities();
    this.getCourses();
  }

  toggleSidebar(): void {
    this._coreSidebarService.getSidebarRegistry('add-ebook').toggleOpen();
  }
  getCategory() {
    this.category = [];
    const params = {};
    this.categoryService.get(params).subscribe(res => {
      if (res && res['data']) {
        this.category = res['data'];
      }
    }, error => {
      this.category = [];
    });
  }
  getUniversities() {
    this.universities = [];
    const params = {};
    this.universityService.get(params).subscribe(res => {
      if (res && res['data']) {
        this.universities = res['data'];
      }
    }, error => {
      this.universities = [];
    });
  }
  getCourses() {
    this.courses = [];
    const params = {};
    this.courseService.get(params).subscribe(res => {
      if (res && res['data']) {
        this.courses = res['data'];
      }
    }, error => {
      this.courses = [];
    });
  }
  refresh() {
    this.addBookForm = this.fb.group({
      'name': ['', Validators.required],
      'category_id': ['', Validators.required],
      'university_id': ['', Validators.required],
      'course_id': ['', Validators.required],
      'semester': ['', Validators.required],
    });
    if (this.data && this.data['id']) {
      this.patchForm();
    }
  }

  patchForm() {
    this.addBookForm.patchValue({
      'name': this.data?.name || '',
      'category_id': this.data?.category_id || '',
      'university_id': this.data?.university_id || '',
      'course_id': this.data?.course_id || '',
      'semester': this.data?.semester || '',
    });
    // existing uploaded file
    if (this.data?.book_file_data?.url) {
      this.uploadedBookUrl = this.data.book_file_data.url;
      this.bookFileId = this.data.book_file_data.id;
    }
  }

  submit() {
    this.submitted = true;
    if (!this.addBookForm.valid) {
      return;
    }
    if (!this.bookFileId) {
      this.alertService.showErrors('Doc Required');
    }
    if (this.submitted) {
      const params = {
        'name': (this.addBookForm.value && this.addBookForm.value.name) ? this.addBookForm.value.name : '',
        'category_id': (this.addBookForm.value && this.addBookForm.value.category_id) ? this.addBookForm.value.category_id : '',
        'university_id': (this.addBookForm.value && this.addBookForm.value.university_id) ? this.addBookForm.value.university_id : '',
        'course_id': (this.addBookForm.value && this.addBookForm.value.course_id) ? this.addBookForm.value.course_id : '',
        'semester': (this.addBookForm.value && this.addBookForm.value.semester) ? this.addBookForm.value.semester : '',
        'book_file_id': this.bookFileId
      };
      this.submitting = true;
      this.ebookService.create(params).subscribe(data => {
        if (data) {
          this.submitting = false;
          this.submitted = false;
          this.valueSubmitted.emit(true);
          this.addBookForm.reset();
          this.addBookForm.patchValue({
            'name': '',
            'category_id': '',
            'university_id': '',
            'course_id': '',
            'semester': '',
          });
          this.uploadedBookUrl = null;
          this.bookFileId = null;
        }
      }, error => {
        this.submitting = false;
        this.submitted = false;
        if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
          if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
            this.alertService.showErrors(error['error']['errors'].name[0]);
            return;
          }
        }
      });
    }
  }

  update() {
    this.submitted = true;
    if (!this.addBookForm.valid) {
      return;
    }
    if (!this.bookFileId) {
      this.alertService.showErrors('Doc Required');
    }
    if (this.submitted) {
      const params = {
        'name': (this.addBookForm.value && this.addBookForm.value.name) ? this.addBookForm.value.name : '',
        'category_id': (this.addBookForm.value && this.addBookForm.value.category_id) ? this.addBookForm.value.category_id : '',
        'university_id': (this.addBookForm.value && this.addBookForm.value.university_id) ? this.addBookForm.value.university_id : '',
        'course_id': (this.addBookForm.value && this.addBookForm.value.course_id) ? this.addBookForm.value.course_id : '',
        'semester': (this.addBookForm.value && this.addBookForm.value.semester) ? this.addBookForm.value.semester : '',
        'book_file_id': this.bookFileId
      };
      this.submitting = true;
      this.ebookService.update(this.data['unique_id'], params).subscribe(data => {
        this.submitting = false;
        this.submitted = false;
        this.valueSubmitted.emit(true);
      }, error => {
        this.submitting = false;
        this.submitted = false;
        if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
          if (error['error']['errors'].name && error['error']['errors'].name.length > 0) {
            this.alertService.showErrors(error['error']['errors'].name[0]);
            return;
          }
        }
      });
    }
  }
  openBook(data: any) {
    if (data && data['book_file'] && data['book_file']['url']) {
      window.open(data['book_file']['url'], '_blank');
    }
  }
  onBookFileChange(event: any, type: string, data: any): void {
    this.onFileChanged = event;

    this.ebookService.fileUpload({
      'type': type,
      'fileType': 'NORMAL',
      'category_id': this.addBookForm.value?.category_id || '',
    }, this.onFileChanged).subscribe(res => {

      if (res && res['data']) {
        this.bookFileId = res['data']['id'] || null;
        this.uploadedBookUrl = res['data']['url'] || null;
      }

      this.alertService.showSuccess({
        title: 'Success',
        message: 'Uploaded Successfully'
      });

    }, error => {
      this.alertService.showErrors('Something went wrong, please try again');
    });
  }

  openUploadedBook() {
    if (this.uploadedBookUrl) {
      window.open(this.uploadedBookUrl, '_blank');
    }
  }
}
